import React from 'react';
import './styles/About.css';

function About () {
    return (
        <section id='aboutMe-section'>
          <p>My name is Robert Patrick Boyle, but most people call me RP.  I'm a fullstack developer that gets excited about the endless possibilities that come with web development and technology.  This profession gives me the opportunity to learn something new everyday, and thats what makes it so unique and special.</p>
          <p>I know this is a cliche thing to say, but I am truly a 'people person'. I love working on teams and meeting clients. Being able to lighten the load for a co-worker so they can get home to their family, or making a client happy by delivering their every need is a very rewarding feeling to me. I think being able and willing to make a difference, both with your work ethic and your personal interactions, is a very important trait to have in a successful work place.</p>
          <p>When I'm not working, I love playing and watching sports, being with family and friends, and trying out any new breweries that have popped up in my neighborhood.</p>
        </section>
    );
}

export default About;